import * as React from 'react';
import { SVGProps } from 'react';

const FileIconVsdSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.999 20.949 19.05 16l-4.448 4.448H8v10h2.368a4 4 0 0 0 7.95 0H26v-10h-2.5l.5.5h-.001Zm-1.413 0-3.536 3.536-3.535-3.535 3.535-3.536 3.536 3.536Zm.916.499-4.452 4.451-4.451-4.451H9v8h1.381a4 4 0 0 1 7.924 0H25v-8h-1.498Zm-7.037 6.431a3 3 0 1 0-4.243 4.243 3 3 0 0 0 4.243-4.243Z"
      fill="#fff"
      opacity={0.6}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 11.77c-.22.153-.487.23-.8.23h-.5c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.77-.38 1.35-.38H20V5h1v7h-1v-.23Zm-.65-.77c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V8h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
    <path
      d="M10 7H9v3l1 2h1l1-2V7h-1v3h-1V7ZM22 12h1v-1.5l1-.5 1 .5V12h1v-2h-1V9h1V7h-1v1.5L24 9l-1-.5V7h-1v2h1v1h-1v2ZM16 10.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H13v-1h1.45c.18 0 .317-.037.41-.11a.423.423 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H16v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconVsdSizeM;
